//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';

import { VirtualizedAsyncSelect } from 'common/components/core/select';
import popOverFactory from 'common/components/core/popover/popOverFactory';

import { translate } from 'react-i18next';
import defaultTheme from './EntityIdInput.scss';

const VirtualizedAsyncSelectWithPopOver = popOverFactory({
    withObserverFlag: true,
    Component: VirtualizedAsyncSelect
});

type Props = {
    portal?: boolean,
    menuPortalZIndex?: number,
    disabled: boolean,
    isLoading: boolean,
    isMulti: boolean,
    clientId: string,
    value: ?Object,
    options: Array<any>,
    theme: Object,
    placeholder: string,
    optionHeight: number,
    loadOptions: Object => Object,
    popOverContent: any,
    isPopOverOpen: boolean,
    getFilters: (input: string) => Object,
    onChange: (?Object) => void,
    t: (string, ?Object) => string,
    getOptionLabelAndValue: Object => string,
    getOptionValue?: Object => string,
    getOptionLabel?: Object => string,
    getOptionMeta?: Object => string,
    customSelectComponent?: React.Component<$FlowFixMeProps>,
    hasError?: boolean
};

class EntityIdInput extends React.Component<Props> {
    defaultProps = {
        options: []
    };

    getOptionLabel = option => {
        const { getOptionLabelAndValue, getOptionLabel } = this.props;
        if (getOptionLabel) {
            return getOptionLabel(option);
        }
        if (getOptionLabelAndValue) {
            return getOptionLabelAndValue(option);
        }
        return option.id;
    };

    getOptionValue = option => {
        const { getOptionLabelAndValue, getOptionValue } = this.props;
        if (getOptionValue) {
            return getOptionValue(option);
        }
        if (getOptionLabelAndValue) {
            return getOptionLabelAndValue(option);
        }
        return option.id;
    };

    getOptionMeta = option => {
        const { getOptionMeta } = this.props;
        if (getOptionMeta) {
            return getOptionMeta(option);
        }
        return option.name;
    };

    getNoOptionsMessage = () => {
        const { t } = this.props;
        return t('translations:noResultsFound');
    };

    render() {
        const {
            portal,
            menuPortalZIndex,
            disabled,
            value,
            optionHeight,
            loadOptions,
            options,
            onChange,
            placeholder,
            isMulti,
            popOverContent,
            isPopOverOpen,
            theme,
            customSelectComponent,
            ...rest
        } = this.props;

        const SelectComponent =
            customSelectComponent || VirtualizedAsyncSelectWithPopOver;
        return (
            <SelectComponent
                {...rest}
                doubleLine
                defaultOptionsOnFocus
                portal={portal}
                menuPortalZIndex={menuPortalZIndex}
                popOverContent={popOverContent}
                isPopOverOpen={isPopOverOpen}
                options={options}
                theme={theme}
                cache={false}
                disabled={disabled}
                loaderInside={false}
                optionHeight={optionHeight || 41}
                openMenuOnFocus
                getOptionMeta={this.getOptionMeta}
                getOptionLabel={this.getOptionLabel}
                getOptionValue={this.getOptionValue}
                fallbackLabelKey="id"
                fallbackValueKey="id"
                loadOptions={loadOptions}
                value={value}
                isMulti={isMulti}
                placeholder={placeholder}
                onChange={onChange}
                noOptionsMessage={this.getNoOptionsMessage}
                noMarginBottom
            />
        );
    }
}

export default themr(
    null,
    defaultTheme
)(translate('entityManagement')(EntityIdInput));
